import { apiRequest } from '@/lib/api-client';

export type AgentType = 'content' | 'media_buyer' | 'analyst' | 'system' | 'video' | 'moviereview';

export interface AgentInfo {
  type: AgentType;
  kind: string;
  description: string;
}

export interface AgentTask {
  id: string;
  agentType: AgentType;
  kind: string;
  status: string;
  error: string | null;
  createdAt: string;
}

export interface AgentRunStep {
  phase: string;
  detail: string;
  at: string;
}

export interface AgentRun {
  id: string;
  taskId: string;
  agentType: AgentType;
  kind: string;
  status: string;
  steps: AgentRunStep[];
  error: string | null;
  startedAt: string;
  finishedAt: string | null;
}

interface Paginated<T> {
  items: T[];
  meta: { total: number };
}

const base = (orgId: string) => `/api/v1/organizations/${orgId}/agents`;

export const agentsApi = {
  list: (orgId: string) => apiRequest<AgentInfo[]>(base(orgId)),
  listTasks: (orgId: string) => apiRequest<Paginated<AgentTask>>(`${base(orgId)}/tasks`),
  listRuns: (orgId: string) => apiRequest<AgentRun[]>(`${base(orgId)}/runs`),
  enqueue: (orgId: string, body: { agentType: AgentType; kind: string }) =>
    apiRequest<{ id: string; status: string }>(`${base(orgId)}/tasks`, { method: 'POST', body }),
};
